import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  useMediaQuery,
} from '@mui/material';
import { Dropzone, FileMosaic } from '@dropzone-ui/react';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { resultadoService } from '../../Services/Form';
import { IUserFromStorage } from '../../Interfaces/IUser';
import { IPesoPorcentaje } from '../ModalEvaluacion/constants';
import { imgManShortV2, imgWomanShortV2 } from '../../Shared/Images/Cuestionario';
import control from './constants';
import Loading from '../../Utils/Loading';
import PesoEvaluacion from '../ModalEvaluacion/EvaluacionComponents/PesoEvaluacion';
import ModalCloseDialog from '../ModalEvaluacion/EvaluacionComponents/ModalCloseDialog';
import PorcentajeDeGrasa from '../ModalEvaluacion/EvaluacionComponents/PorcentajeDeGrasa';


interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

function ModalLlenarPesosResultado({ isOpen, setIsOpen }: Props) {
  const [files, setFiles] = useState<any[]>([]);
  const [imgBase64Data, setImgBase64Data] = useState<string[]>([]);
  const [mes, setMes] = useState<number>(1);
  const [pesoPorcentaje, setPesoPorcentaje] = useState<IPesoPorcentaje>({
    peso: 0,
    porcentajeGrasa: 0,
    unidadPeso: 'Kg',
  });
  const [isOpenModalConfirmar, setIsOpenModalConfirmar] = useState<boolean>(false);
  const [isOpenModalCloseDialog, setIsOpenModalCloseDialog] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const sexoUser: boolean = localStorage.getItem('sexoUser') ? JSON.parse(localStorage.getItem('sexoUser')) : true;

  const user: IUserFromStorage = JSON.parse(localStorage.getItem('user'));
  // const currentMembresia = JSON.parse(localStorage.getItem('cantidadMembresiasClub'));

  const isMobile = useMediaQuery("(max-width:768px)");

  const updateFiles = (incommingFiles: any[]) => {
    let aux: string[] = [];
    incommingFiles.forEach((e: any) => {
      if (e.valid === true) {
        let reader = new FileReader();
        reader.readAsDataURL(e.file);
        reader.onload = () => {
          let arrayBase64 = String(reader.result).split(',');
          aux.push(arrayBase64[1]);
        };
      }
    });
    setImgBase64Data(aux);
    setFiles(incommingFiles);
  };

  const onDelete = (id: any) => {
    const updatedFiles = files.filter((x: any) => x.id !== id);
    setFiles(updatedFiles);
    setImgBase64Data(updatedFiles.map(file => file.base64));
  };

  function handleChange(type: string, value: string | number) {
    switch (type) {
      case 'peso':
        setPesoPorcentaje((prev) => ({
          ...prev,
          peso: Number(value),
        }));
        break;
      case 'porcentajeGrasa':
        setPesoPorcentaje((prev) => ({
          ...prev,
          porcentajeGrasa: Number(value),
        }));
        break;
      case 'unidadPeso':
        setPesoPorcentaje((prev) => ({
          ...prev,
          unidadPeso: String(value),
        }));
        break;
      default:
        break;
    }
  }
  
  useEffect(() => {
    setIsLoading(true);
    resultadoService({
      UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID
    })
      .then((res) => {
        setPesoPorcentaje({
          peso: 0,
          porcentajeGrasa: 0,
          unidadPeso: res.data.data.unidadPeso
        });
        setMes( res.data.data.mes );
      })
      .finally(() => {
        setIsLoading(false);
      })
  }, [])

  // function sendData() {
  //   if (files.length < 3) {
  //     toast.error('Tienen que ser mínimo 3 imágenes 😢.');
  //     return;
  //   }

  //   setIsLoading(true);
  //   subirControlFotos({
  //     Fotos: imgBase64Data,
  //     Peso: pesoPorcentaje.peso,
  //     PorcentajeGrasa: pesoPorcentaje.porcentajeGrasa,
  //     UnidadPeso: pesoPorcentaje.unidadPeso,
  //     UsuarioTestAsesoriaID: user ? user.usuarioTestAsesoriaID : 0,
  //   })
  //     .then(() => {
  //       toast.success('Datos enviados correctamente.');
  //       setIsOpen(false);
  //     })
  //     .catch(() => toast.error('Sucedió un error, por favor, vuelve a intentarlo'))
  //     .finally(() => setIsLoading(false));
  // }

  // function pruebaDeFuego() {
  //   setIsLoading(true)
  //   setTimeout(() => {
  //     console.log(imgBase64Data);
  //     console.log(pesoPorcentaje);
  //     toast.success('Datos enviados correctamente.');
  //     setIsLoading(false);
  //     setIsOpen(false);
  //   }, 3000);
  // }

  return (
    <>   
      <Dialog open={isOpen} onClose={() => setIsOpenModalCloseDialog(true)} className="relative" fullWidth>
        <DialogTitle className="flex justify-center" style={{ fontWeight: 'bold' }}>
          <p className="text-xl m-0">{control[mes - 1]?.titulo ? control[mes - 1]?.titulo : control[0].titulo}</p>
        </DialogTitle>
        <DialogContent className="flex flex-col ">
          <p>{control[mes - 1]?.desc ? control[mes - 1]?.desc : control[0].desc}</p>
          {/* Foto */}
          <section className="flex flex-col gap-1">
            <b className="text-orangeTr4iner text-xl text-center">Sube tus fotos</b>
            <div className="flex flex-col w-full m-auto">
              <div className="mt-1 flex justify-start items-center w-full font-semibold mb-2">
                <span className="h4 font-bold text-left">1&nbsp;.&nbsp;</span>
                Torso descubierto, con SHORT deportivo.
              </div>
              <div className="flex justify-start items-center w-full font-semibold mb-2">
                <span className="h4 font-bold">2&nbsp;.&nbsp;</span>
                Ni bien te levantas. Frente a una pared clara.
              </div>
              <div className="flex justify-start items-center w-full font-semibold mb-2">
                <span className="h4 font-bold ">3&nbsp;.&nbsp;</span>
                Solo 3 fotos(De frente, Perfil, De espalda).
              </div>
              <div className="flex justify-start items-center w-full font-semibold">
                <span className="h4 font-bold">4&nbsp;.&nbsp;</span>
                De cuerpo entero.
              </div>
            </div>
            <div className="flex text-center items-center justify-center">
              <img src={sexoUser ? imgManShortV2 : imgWomanShortV2} width="250px" alt="img" />
            </div>
            <Dropzone
              onChange={updateFiles}
              accept="image/*"
              localization='ES-es'
              label='Sube tus archivos aquí'
              maxFiles={3}
              header={false}
              value={files}
            >
              {files
                .filter((e: any) => e.valid === true)
                .map((file: any) => (
                  <FileMosaic {...file} key={file.id} onDelete={onDelete} preview />
                ))}
            </Dropzone>
            <p className="text-slate-400 text-xs text-left mt-2">
              Respetamos tu privacidad. Estas fotos no se divulgarán sin tu consentimiento.
            </p>
          </section>
          {/* Peso */}
          
          <PesoEvaluacion
            dataEvaluacion={pesoPorcentaje}
            handleChange={handleChange}
          />

          <div>
            <PorcentajeDeGrasa 
              handleChange={handleChange}
              sexo={sexoUser}
            />
          </div>

          {/* Enviar data */}
          <Button
            variant="contained"
            style={{ backgroundColor: '#FDBA29' }}
            // onClick={() => abrirModalConfirmar({data: pesoPorcentaje, files: files, setIsOpenModalConfirmar: setIsOpenModalConfirmar})}
            disabled={files.length < 1} // Habilitar el botón solo si hay al menos 3 imágenes
          >
            Vamos al mes { mes }
          </Button>
          {isLoading && (
            <div className="absolute w-full bg-slate-900/40 h-full top-0 left-0 z-2 flex items-center justify-center">
              <Loading />
            </div>
          )}
        </DialogContent>
      </Dialog>
      {/* {isOpenModalConfirmar && (
        <ModalConfirmarEvaluacion
          isOpen={isOpenModalConfirmar}
          setIsOpen={setIsOpenModalConfirmar}
          sendData={sendData}
        />
      )} */}
      {isOpenModalCloseDialog && (
        <ModalCloseDialog
          isOpen={isOpenModalCloseDialog}
          setIsOpen={setIsOpenModalCloseDialog}
        />
      )}
    </>
  );
}

export default ModalLlenarPesosResultado;
